import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";
export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']

export const SnowTableConfig = {
  tableInfo: {
    type: 'dataTable',
    title: {
      display: true,
      text: '',
      align: 'center',
      order: 'order-md-2'
    }
  },
  css: {
    tableClass: 'table table-striped table-bordered m-0',
    theadClass: '',
    tbodyClass: ''
  },
  searchFilter: {
    display: true
  },
  breadcrumbCons: {
    show: true,
    queryparams: []
  },
  printButton: {
    display: true,
    text: 'Print',
    align: 'right',
    order: 'order-md-2',
    title: 'Snow Count'
  },
  paginatorOptions: {
    visible: false
  },
  tableHeaderFixerInfo: {
    headerFix: true,
    colFix: true,
    rowFix: false,
    noOfCol: 1,
    height: '500px'
  },
  totalRow: {
    position: 'bottom',
    name: 'Total',
    jsonKey: '-1',
    colspan: 1,
    class: 'fixed-row'
  },
  indexCons: {
    show: false
  },
  downloadButton: {
    display: true,
    text: 'Download',
    align: 'right',
    order: 'order-md-3',
  },
  downloadOptions: [
    {
      downloadType: 'xlsx',
      downloadFileName: 'Snow Data',
      downloadAll: true,
      metaData: false
    }
  ],
  columns: []
};

export const SnowColumnConfig = [
  {
    name: 'State',
    jsonKey: { path: 'locName##locUUID' },
    dataType: 'LOCATION'
  }
];

export const ADMIN_LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']

export const SNOW_LAYER_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    'India Boundary': {
      source: 'INDIA',
      displayName: 'India',
      name: 'India Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'odisha:india_boundary',
      layer_name: 'India Boundary',
      layeroptions_pane: 'base',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      layeroptions_protocol: 'WFS'
    },
    'State Boundary': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'SNOW_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'State Boundaries': {
      source: 'INDIA',
      displayName: 'State Boundaries',
      name: 'State Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
      layer_name: 'State Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'UUID',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'District Boundaries': {
      source: 'INDIA',
      displayName: 'District Boundaries',
      name: 'District Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
      layer_name: 'District Boundaries',
      layeroptions_pane: 'max',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'UUID',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'District Boundary': {
      source: 'INDIA',
      displayName: 'District',
      name: 'District Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
      layer_name: 'District Boundary',
      layeroptions_pane: 'district',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'SNOW_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'Block Boundary': {
      source: 'INDIA',
      displayName: 'Block',
      name: 'Block Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
      layer_name: 'Block Boundary',
      layeroptions_pane: 'state',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'SNOW_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'State Boundary Labels': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
      crs: 'EPSG4326',
    },
    'District Boundary Labels': {
      source: 'INDIA',
      displayName: 'District Boundary Labels',
      name: 'District Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
      layer_name: 'District Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'State_UUID',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
      crs: 'EPSG4326',
    },
    'Block Boundary Labels': {
      source: 'INDIA',
      displayName: 'Block Boundary Labels',
      name: 'Block Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
      layer_name: 'Block Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'Dist_UUID',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
      crs: 'EPSG4326',
    },
    'Airport Boundary': {
      source: 'INDIA',
      displayName: 'Airport Boundary',
      name: 'Airport Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:India_Airport_Points',
      layer_name: 'Airport Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      pointToLayer: 'handleAirportPointLayer',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS',
      restrictFitBounds: true
    },
    'Railway Boundary': {
      source: 'INDIA',
      displayName: 'Railway Boundary',
      name: 'Railway Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:India_Railway_lines',
      layer_name: 'Railway Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'SNOW_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'Highway Boundary': {
      source: 'INDIA',
      displayName: 'Highway Boundary',
      name: 'Highway Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:India_highway',
      layer_name: 'Highway Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'SNOW_LEGEND',
      layeroptions_protocol: 'WFS'
    },
  }
}

export const SNOW_LEGEND_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    SNOW_LEGEND: {
      "Units": "",
      "colorValues": [
        {
          backgroundColor: '#FFFFFF',
          text: 'Snow',
          textColor: '#000000'
        }
      ]
    }
  }
}

export const SnowMapConstants: any = {
  HeatMapOptions: {
    type: 'Time',
    time: '24',
    clip: true,
    view: 'Admin',
    serviceType: 'HeatMap'
  }
}

export const SNOWALERT_VIEWTYPE: any = {
  'Airport Boundary': 'Airport',
  'Railway Boundary': 'Railway',
  'Highway Boundary': 'Highway'
}

export function getSnowAdvisoryHTML(sector, category) {
  const advisories: any = {
    Airport: {
      'Very Heavy Snowfall': [
        'Extreme snowfall accumulation',
        'Airport closure highly likely',
        'All flights will be cancelled or diverted',
        'De-icing operations at maximum capacity',
        'Passengers advised to avoid travel'
      ],
      'Heavy Snowfall': [
        'Significant snowfall accumulation',
        'Major flight delays and cancellations expected',
        'Extended de-icing and runway clearing times',
        'Passengers advised to check flight status before departure'
      ],
      'Moderate Snowfall': [
        'Moderate snowfall affecting operations',
        'Delays possible during peak hours',
        'Enhanced de-icing procedures in effect',
        'Passengers advised to arrive early'
      ],
      'Light Snowfall': [
        'Minor snowfall accumulation',
        'Some delays possible',
        'Normal operations with caution',
        'Regular de-icing procedures'
      ],
      'Very Light Snowfall': [
        'Minimal snowfall',
        'Minimal impact on operations',
        'Standard airport operations in effect'
      ],
      'No Snowfall': [
        'Normal weather conditions',
        'Standard operations in effect'
      ]
    },

    Railway: {
      'Very Heavy Snowfall': [
        'Extreme snow accumulation on tracks',
        'All train services suspended',
        'Snow clearing operations at maximum capacity',
        'High risk of track blockages and signal failures',
        'Passengers advised to avoid rail travel'
      ],
      'Heavy Snowfall': [
        'Significant snow accumulation',
        'Severe speed restrictions (50–70% reduction)',
        'High likelihood of delays and cancellations',
        'Enhanced snow clearing operations',
        'Passengers advised to check train status'
      ],
      'Moderate Snowfall': [
        'Moderate snow accumulation',
        'Speed restrictions (30–50% reduction)',
        'Delays possible on affected routes',
        'Regular snow clearing operations'
      ],
      'Light Snowfall': [
        'Light snow accumulation',
        'Minor speed restrictions',
        'Normal operation with increased caution',
        'Localized delays possible'
      ],
      'Very Light Snowfall': [
        'Minimal snow accumulation',
        'Normal rail operations',
        'Increased vigilance at junctions'
      ],
      'No Snowfall': [
        'Normal rail operations',
        'Standard speed limits apply'
      ]
    },

    Highway: {
      'Very Heavy Snowfall': [
        'Extreme snow accumulation on roads',
        'Road closures highly likely',
        'Very high accident risk',
        'Snow chains or winter tires mandatory',
        'Avoid all non-essential travel'
      ],
      'Heavy Snowfall': [
        'Heavy snow accumulation',
        'Significant speed reduction advised (20–40 km/h)',
        'High accident risk',
        'Winter tires recommended',
        'Maintain large following distance'
      ],
      'Moderate Snowfall': [
        'Moderate snow accumulation',
        'Speed reduction advised (40–60 km/h)',
        'Increased accident risk',
        'Overtaking discouraged',
        'Use headlights at all times'
      ],
      'Light Snowfall': [
        'Light snow accumulation',
        'Drive with caution',
        'Reduced speed advised',
        'Be aware of slippery patches'
      ],
      'Very Light Snowfall': [
        'Minimal snow accumulation',
        'Normal driving with caution',
        'Be prepared for changing conditions'
      ],
      'No Snowfall': [
        'Normal road conditions',
        'Standard speed limits apply'
      ]
    }
  };

  const sectorAdvisory = advisories[sector];
  const messages = sectorAdvisory && sectorAdvisory[category]
    ? sectorAdvisory[category]
    : [];

  if (!messages.length) {
    return '';
  }

  let html = `
      <div class="advisory-title">
        <i class="fa fa-exclamation-triangle text-warning"></i>
        <span class="title">Snow Advisory</span>
        </div>
      <ul class="advisory-list">
  `;

  messages.forEach((msg: string) => {
    html += `<li>${msg}</li>`;
  });

  html += `
      </ul>
    </div>
  `;

  return html;
}

export const SNOW_CATEGORY_CONFIG: any = {
  'Very Heavy Snowfall': {
    label: 'Very Heavy Snowfall',
    dotClass: 'snow-dot-very-heavy',
    alertText: 'Red',
    alertClass: 'text-danger',
    headerStyle: { 'background': '#8B0000' },
  },
  'Heavy Snowfall': {
    label: 'Heavy Snowfall',
    dotClass: 'snow-dot-heavy',
    alertText: 'Dark Orange',
    alertClass: 'text-orange-dark',
    headerStyle: { 'background': '#FF4500' }
  },
  'Moderate Snowfall': {
    label: 'Moderate Snowfall',
    dotClass: 'snow-dot-moderate',
    alertText: 'Orange',
    alertClass: 'text-orange',
    headerStyle: { 'background': '#FFA500' }
  },
  'Light Snowfall': {
    label: 'Light Snowfall',
    dotClass: 'snow-dot-light',
    alertText: 'Yellow',
    alertClass: 'text-warning',
    headerStyle: { 'background': '#FFD700' }
  },
  'Very Light Snowfall': {
    label: 'Very Light Snowfall',
    dotClass: 'snow-dot-very-light',
    alertText: 'Light Blue',
    alertClass: 'text-info-light',
    headerStyle: { 'background': '#87CEEB' }
  },
  'No Snowfall': {
    label: 'No Snowfall',
    dotClass: 'snow-dot-none',
    alertText: 'Green',
    alertClass: 'text-success',
    headerStyle: { 'background': '#228B22' }
  }
};

export const SNOWALERT_API_MAPPING: any = {
  Railway: 'snow/getSnowfallData',
  Highway: 'snow/getSnowfallData',
  Airport: 'nowcast/getAirPortSnowData',
  Aviation_Count: 'nowcast/getAirportSnowCategoryCount'
}

export const ALERT_COLOR_MAPPING_SNOW: any = {
  'No Snowfall': '#FFFFFF',
  'Very Light Snowfall': '#E3F2FD',
  'Light Snowfall': '#BBDEFB',
  'Moderate Snowfall': '#64B5F6',
  'Heavy Snowfall': '#1976D2',
  'Very Heavy Snowfall': '#0D47A1'
}

export const SECTOR_ICON_CLASS_SNOW: any = {
  Railway: 'fa fa-train text-light mr-2',
  Highway: 'fa fa-road text-light mr-2',
  Airport: 'fa fa-plane text-light mr-2'
}

export const FORMAT_VS_SOURCEMAPPING_SNOW: any = {
  DAILY: {
    'ecmwf_1hr': 'ecmwf_1hr_snow_daily',
    'ecmwf_1hr_snow_accumulation': 'ecmwf_1hr_snow_accumulation_daily'
  },
  HOURLY: {
    'ecmwf_1hr': 'ecmwf_1hr_snow_hourly',
    'ecmwf_1hr_snow_accumulation': 'ecmwf_1hr_snow_accumulation_hourly'
  }
}

export const SNOW_COLOR_MAPPING_ALT: any = {
  'No Snowfall': '#FFFFFF',
  'Very Light Snowfall': '#F0F8FF',
  'Light Snowfall': '#ADD8E6',
  'Moderate Snowfall': '#4682B4',
  'Heavy Snowfall': '#1E3A5F',
  'Very Heavy Snowfall': '#0A1F44'
}

export const SNOW_INTENSITY_THRESHOLDS: any = {
  'No Snowfall': { min: 0, max: 0 },
  'Very Light Snowfall': { min: 0.1, max: 1.0 },
  'Light Snowfall': { min: 1.1, max: 2.5 },
  'Moderate Snowfall': { min: 2.6, max: 5.0 },
  'Heavy Snowfall': { min: 5.1, max: 10.0 },
  'Very Heavy Snowfall': { min: 10.1, max: 999 }
}

export const SNOW_ACCUMULATION_WARNINGS: any = {
  'Highway': {
    'Warning': 5,
    'Alert': 10,
    'Severe': 20
  },
  'Railway': {
    'Warning': 10,
    'Alert': 20,
    'Severe': 30
  },
  'Airport': {
    'Warning': 2,
    'Alert': 5,
    'Severe': 10
  }
}
